import {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {envAwarePost} from '../../util/util'
import {
	getProgram,
	getPrograms,
	selectProgramById,
	selectAllPrograms,
	getProgramEventLinks
} from './programsSlice'

export const usePrograms = ()=>{
	const dispatch = useDispatch()
	const status = useSelector( state => state.programs.programs.status )
	if (status==='init') {
		dispatch(getPrograms())
	}

	const programs = useSelector(selectAllPrograms)
	const map = useSelector(state=>state.programs.programs.entities)

	return {status,programs,map}
}

//use top level program data (name, length, notes)
export const useProgram = id => {
	const dispatch = useDispatch()
	const status = useSelector( 
		state => {
			if (selectProgramById(state,id)) return 'idle'
			if (state.programs.pending.programs[id]) return 'pending'
			return 'init'
		}
	)
	const program = useSelector(state=>selectProgramById(state,id))

	if ( status === 'init' ) {
		dispatch(getProgram(id))
	}

	return {status,program}
}

//use the event links associated with the program
export const useProgramEventLinks = id => {
	const dispatch = useDispatch()
	const status = useSelector( 
		state => {
			if(state.programs.eventLinks[id]) return 'idle'
			if(state.programs.pending.eventLinks[id]) return 'pending'
			return 'init'
		}
	)
	const {links,instances,instancesByDay} = useSelector( state => state.programs.eventLinks[id] || {} )

	if (status==='init') {
		dispatch(getProgramEventLinks(id))
	}

	const {status:programStatus,program} = useProgram(id)

	const weeks = [];
	if(instancesByDay&&programStatus==='idle'){
		const L = parseInt(program.programLength)
		for (let i = 0; i < Math.ceil(L/7); i++) {
			const week = []
			for (let j = 1; j <= 7; j++) {
				const day = i*7 + j
				week.push(instancesByDay[day]||[])
			}
			weeks.push(week)
		}
	}

	return {status,links,instances,instancesByDay,weeks}
}

export const useClientsForAssignment = programId =>{
	const [status,setStatus] = useState('pending')
	const [clients,setClients] = useState([])
	const [warning,setWarning] = useState("")
	useEffect(()=>{
		setStatus('pending')
		setClients([])
		envAwarePost('api/programs/api/',{
			action:'getClientsForAssignment',
			program_id:programId
		}).then(res=>{
			setClients(res.data.clients)
			setWarning(res.data.warning)
			setStatus('idle')
		})
	},[programId])

	return {status,warning,clients}
}

export const useEventLinkEditor = () => useSelector(state=>state.programs.eventLinkEditor)